import React, { useState } from "react";
import NavbarHome from "../components/ui/NavbarHome";
import { toast } from "react-toastify";
import axios from "axios";
import { devURL, mailformat } from "../utils";
import "./Home/Home.css";
export default function EarlyBird() {
  const [email, setEmail] = useState("");

  const handleChange = (e) => {
    setEmail(e.target.value);
  };
  const handleSubmit = () => {
    if (email && !email.match(mailformat)) {
      toast.error("You have entered an invalid email address!");
    } else if (email) {
      axios.post(`${devURL}/user/fetchEmail`, {
        email: email,
      });
      toast.success(
        "Thank you for your interest. We will get back to you soon!"
      );
    } else {
      toast.error("Please enter your email address!.");
    }
  };
  return (
    <>
      <NavbarHome />
      <div className="font-nunito px-4">
        <div className="page-title text-xl font-bold mt-10 mb-4">
          <p>Interested in knowing more about us?</p>
        </div>
        <div className="flex justify-center text-lg font-medium">
          ... of the Indians, by the Indians, for the Indians
        </div>
        <div className="my-10 flex items-center justify-center">
          <div className="bg-white px-2 py-10 shadow-lg rounded-sm justify-center sw-shadow w-3/4 xl:w-2/6 m-2 -ml-12 lg:-ml-0">
            <div>
              <div className="flex justify-center text-xl font-semibold">
                Join our journey and stay tuned!
              </div>
              <div className="flex justify-center">
                <input
                  placeholder="Enter your email"
                  className="border-2 mt-6 w-3/5 py-2 rounded-lg pl-2"
                  onChange={handleChange}
                ></input>
              </div>
              <div className="flex justify-center mt-6">
                <button
                  className="bg-themeColor hover:bg-themeHover text-[white] font-semibold px-4 py-2  rounded-md text-md"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
